export function createProyecto() {
  return {
    Clave: '',
    ClavePadre: '',
    EmpresaId: 0,
    Nombre: '',
    ClaveErp: '',
    EsActivo: true,
    Descripcion: '',
    FechaInicio: null,
    FechaFin: null,
    SocioNegocioClave: '',
    SocioNegocioNombre: '',
    SocioNegocioClaveFiscal: '',
    Responsable: '',
    Direccion: '',
    Telefono: '',
    Email: '',
    Presupuesto: 0,
    CostoActual: 0,
    PorcentajeAvance: 0,
    Estatus: '',
    Notas: ''
  };
}
